// extracted by mini-css-extract-plugin
export default {"name_cell":"TableNameLink_name_cell__BTpQJ"};